import { Component, OnInit, AfterContentInit, Inject, OnDestroy} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { ChatService } from './services/chat.service';
import { CanonicalUrlService } from './meta/services/canonical-url.service';
import { SegmentAnalyticsService } from './services/segment-analytics.service';
import { LocaleService } from './services/locale.service';
import { HCaptchaService } from './services/hcaptcha.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterContentInit, OnDestroy {

  constructor(
    private router: Router,
    private ga: GoogleAnalyticsService,
    private chatService: ChatService,
    private canonicalUrlService: CanonicalUrlService,
    private segmentAnalyticsService: SegmentAnalyticsService,
    private hCaptchaService: HCaptchaService,
    private localeService: LocaleService,
  ) {}

  ngOnInit() {
    // Chat
    this.chatService.init();

    // Canonical Urls
    this.canonicalUrlService.init();

    // Google Analytics
    this.ga.init();

    // Segment SDK
    this.segmentAnalyticsService.init();

    // captcha
    this.hCaptchaService.init();

    // RTL
    if (this.localeService.isArabic()) {
      const body = document.getElementsByTagName('body')[0];
      body.classList.add('rtl');
      // Adding this to enalbe rtl support in ng-material components eg: mat-checkbox
      body.setAttribute('dir', 'rtl');
    }
  }

  ngAfterContentInit() {
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // Scroll
      window.scroll(0, 0);
      window.document.body.classList.remove('noscroll');
      window.document.body.classList.remove('noscroll-mobile');
    });
  }

  ngOnDestroy() {
    this.hCaptchaService.remove();
  }
}
